import { defineStore } from "pinia";
import { api, getToken, setToken } from "../api";

export const useSessionStore = defineStore("session", {
  state: () => ({
    user: null,
    schools: [],
    selectedSchoolId: "",
    ready: false,
  }),
  getters: {
    isSuper: (state) => state.user?.role === "super_admin",
    isParent: (state) => state.user?.role === "parent",
    schoolQuery: (state) =>
      state.selectedSchoolId ? `?schoolId=${state.selectedSchoolId}` : "",
  },
  actions: {
    async restore() {
      if (!getToken()) {
        this.ready = true;
        return;
      }
      try {
        this.user = (await api("/api/auth/me")).user;
        await this.loadSchools();
      } catch {
        setToken("");
        this.user = null;
      } finally {
        this.ready = true;
      }
    },
    async login(username, password) {
      const result = await api("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ username, password }),
      });
      setToken(result.token);
      this.user = result.user;
      await this.loadSchools();
    },
    logout() {
      setToken("");
      this.user = null;
      this.schools = [];
      this.selectedSchoolId = "";
    },
    async loadSchools() {
      this.schools = (await api("/api/schools")).schools || [];
      if (!this.isSuper && this.user?.school_id)
        this.selectedSchoolId = String(this.user.school_id);
    },
  },
});
